import enEN from "./en-EN"

export default {
  "en-EN": enEN
}
